import { Polyline } from "react-leaflet";
import { LeafletMouseEvent } from "leaflet";
import { FenceSegment } from "models/fenceSegment";

const selectedLineColor = "#2af713";
const otherLineColor = "#ffae00";

type FenceLineProps = {
  coords: Array<{ lat: number; lon: number }>;
  fenceId: string;
  clickFunc: (fenceId: string) => (e: LeafletMouseEvent) => void;
  isSelected: boolean;
};

const FenceLine = function ({ coords, fenceId, clickFunc, isSelected }: FenceLineProps) {
  const positions: [number, number][] = coords.map((c) => [c.lat, c.lon]);
  return (
    <Polyline
      positions={positions}
      pathOptions={{
        color: isSelected ? selectedLineColor : otherLineColor,
        weight: 6,
      }}
      eventHandlers={{ click: clickFunc(fenceId) }}
    />
  );
};

type Props = {
  selectedFenceId: string;
  fences: ReadonlyArray<FenceSegment>;
  onClick: (fenceId: string) => (e: LeafletMouseEvent) => void;
};

export const FenceOutline = function ({ selectedFenceId, fences, onClick }: Props) {
  return (
    <>
      {fences.map((f) => (
        <FenceLine
          key={f.id}
          coords={f.getCoords()}
          fenceId={f.id}
          clickFunc={onClick}
          isSelected={f.id === selectedFenceId}
        />
      ))}
    </>
  );
};
